<ng-container *ngIf="control; else skeleton">
<dk-ctl-sablon #sablonCmp
    [isReadOnly]="isReadOnly" [labelText]="labelText" [labelMode]="labelMode" [title]="title" [code]="code"
    [validationRules]="validationRulesMap" [validationV2]="validationV2" [warningMessage]="warningMessage"
    (handleValueChange)="handleValueChange($event)" (codeChanges)="code = $event"
    (searchClick)="searchClick()"
    (clear)="clear()">
</dk-ctl-sablon>  
<dx-popup *ngIf="crudPopupVisible"
    title="Birim Arama"
    [resizeEnabled]="false"
    [hideOnOutsideClick]="false"
    [showCloseButton]="true"
    [(visible)]="crudPopupVisible"
    (onHiding)="closePopupAfter($event, sablonCmp)"
>
        <dk-ctl-gen-birim-arama
        [control]="control"
        (closePopup)="closePopupAfter($event, sablonCmp)"
        ></dk-ctl-gen-birim-arama>
</dx-popup>
<dx-toast [(visible)]="toastVisible" type="error" [message]="toastMessage" [displayTime]="3000">
</dx-toast>
</ng-container>
<ng-template #skeleton>
  <div class="skeleton-control"></div>
</ng-template>
